module.exports = __webpack_public_path__ + "static/media/POI.cce1eb2e.svg";